import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset window scroll on route change. The app shell scrolls at the document
 * level, so React Router leaves the previous page's scroll offset in place
 * when you navigate between sections via the sidebar. Keyed on `pathname`
 * only, so an in-page search-param update (e.g. ?brief=today) does not jump
 * the view. A hash means a section on the new page should take the scroll.
 *
 * A layout effect, so the reset lands before the new page's first paint. A
 * passive effect runs after it, and the page paints once at the old offset
 * before jumping to the top, which reads as the content leaping on arrival.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  // pathname retriggers the reset; hash is the only value read in the body.
  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname is the re-run trigger
  useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
